import React from 'react';
import CustomInput from 'Common/CustomInput';
import { IoLockClosedOutline } from 'react-icons/io5';

const ResetPasswordStep1 = ({ currentPassword, onInputChange }) => (
  <div className="space-y-2">
    <div className="flex flex-col justify-center items-center py-4 text-center">
      <div className="flex justify-center items-center p-3 mb-3 bg-[rgba(96,79,248,0.12)] rounded-full">
        <IoLockClosedOutline size={28} className="text-primary" />
      </div>
      <div className="text-base text-gray-700">
        Please enter your current password to verify your identity before setting a new one.
      </div>
    </div>
    <div className="w-full">
      <CustomInput
        autoComplete="off"
        value={currentPassword}
        name="currentPassword"
        label="Current Password"
        placeholder="Enter your current password"
        toLower
        type="password"
        onChange={onInputChange}
        maxLength={40}
      />
    </div>
  </div>
);

export default ResetPasswordStep1; 